/* KKO³ — Pied de page : carrés du logo (K 19, K 19, O 8) qui dérivent en arrière-plan
   et s'écartent en tournant au passage de la souris. Activé par data-cubes="on" sur .kko-ft.
   Tourne seulement quand le pied de page est visible. Respecte prefers-reduced-motion. */
(function () {
  var ft = document.querySelector('.kko-ft[data-cubes="on"]');
  if (!ft) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var TILES = [{ g: 'K', n: '19' }, { g: 'K', n: '19' }, { g: 'O', n: '8' }];
  function rand(a, b) { return a + Math.random() * (b - a); }

  var layer = document.createElement('div');
  layer.className = 'kko-ft__cubes';
  layer.setAttribute('aria-hidden', 'true');
  ft.insertBefore(layer, ft.firstChild);

  var W = ft.clientWidth, H = ft.clientHeight;
  var count = W < 700 ? 8 : 16;
  var cubes = [];
  for (var i = 0; i < count; i++) {
    var t = TILES[i % TILES.length];
    var size = rand(W < 700 ? 30 : 38, W < 700 ? 56 : 78);
    var el = document.createElement('span');
    el.className = 'kko-ft__cube' + (Math.random() < 0.22 ? ' is-accent' : '');
    el.style.width = el.style.height = size.toFixed(0) + 'px';
    el.style.fontSize = (size * 0.5).toFixed(0) + 'px';
    el.innerHTML = '<span class="kko-ft__cube-n">' + t.n + '</span><span class="kko-ft__cube-g">' + t.g + '</span>';
    layer.appendChild(el);
    cubes.push({
      el: el, r: size / 2,
      x: rand(size, Math.max(size + 1, W - size)), y: rand(size, Math.max(size + 1, H - size)),
      vx: rand(-0.18, 0.18), vy: rand(-0.14, 0.14),
      rot: rand(-20, 20), vr: rand(-0.08, 0.08), heat: 0
    });
  }

  var mouse = { x: -9999, y: -9999, on: false };
  var visible = false, running = false;

  function tick() {
    if (!visible) { running = false; return; }
    W = ft.clientWidth; H = ft.clientHeight;
    cubes.forEach(function (c) {
      var dx = c.x - mouse.x, dy = c.y - mouse.y, d2 = dx * dx + dy * dy, R = 150;
      if (mouse.on && d2 < R * R) {
        var d = Math.sqrt(d2) || 1, f = (R - d) / R;
        c.vx += dx / d * f * 0.9;
        c.vy += dy / d * f * 0.9;
        c.vr += (dx > 0 ? 1 : -1) * f * 0.6;
        c.heat = Math.min(1, c.heat + f * 0.25);
      }
      c.vx *= 0.95; c.vy *= 0.95; c.vr *= 0.94;
      c.vx += rand(-0.01, 0.01); c.vy += rand(-0.01, 0.01);
      if (Math.abs(c.vx) < 0.05) c.vx += (c.vx >= 0 ? 0.004 : -0.004);
      c.x += c.vx; c.y += c.vy; c.rot += c.vr + 0.03;
      if (c.x < c.r) { c.x = c.r; c.vx = Math.abs(c.vx); }
      if (c.x > W - c.r) { c.x = W - c.r; c.vx = -Math.abs(c.vx); }
      if (c.y < c.r) { c.y = c.r; c.vy = Math.abs(c.vy); }
      if (c.y > H - c.r) { c.y = H - c.r; c.vy = -Math.abs(c.vy); }
      c.heat *= 0.96;
      c.el.style.transform = 'translate(' + (c.x - c.r).toFixed(1) + 'px,' + (c.y - c.r).toFixed(1) + 'px) rotate(' + c.rot.toFixed(1) + 'deg)';
      c.el.classList.toggle('is-hot', c.heat > 0.15);
    });
    requestAnimationFrame(tick);
  }
  function start() { if (!running) { running = true; requestAnimationFrame(tick); } }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); }, { rootMargin: '100px' }).observe(ft);
  } else { visible = true; start(); }

  if (fine) {
    ft.addEventListener('mousemove', function (e) {
      var r = ft.getBoundingClientRect();
      mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top; mouse.on = true;
    });
    ft.addEventListener('mouseleave', function () { mouse.on = false; mouse.x = mouse.y = -9999; });
  } else {
    ft.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; if (!t) return;
      var r = ft.getBoundingClientRect();
      mouse.x = t.clientX - r.left; mouse.y = t.clientY - r.top; mouse.on = true;
      setTimeout(function () { mouse.on = false; }, 450);
    }, { passive: true });
  }
})();
